
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/15",
      function () {
        return require("private-next-pages/15.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/15"])
      });
    }
  